import { gql } from '@apollo/client'

const BASE_CANADIAN_DAT_TIP_FIELDS = gql`
  fragment BaseCanadianDatTipFields on CanadianDatTipType {
    id
    title
    description
  }
`

export const FIND_ALL_CANADIAN_DAT_TIPS = gql`
  ${BASE_CANADIAN_DAT_TIP_FIELDS}
  query findAllCanadianDatTips($query: CanadianDatTipQueryInput!) {
    findAllCanadianDatTip(query: $query) {
      count
      items {
        ...BaseCanadianDatTipFields
      }
    }
  }
`

export const UPDATE_CANADIAN_DAT_TIP = gql`
  ${BASE_CANADIAN_DAT_TIP_FIELDS}
  mutation updateCanadianDatTip($input: UpdateCanadianDatTipInput!) {
    updateCanadianDatTip(updateCanadianDatTipsInputFieldName: $input) {
      ...BaseCanadianDatTipFields
    }
  }
`
